<template>
  <section v-if="sections" class="collection-story underline-links">
    <component 
      class="collection-story--block"
      v-for="(block, index) in sections" 
      :key="index"
      v-if="showBlock(block)"
      :is="setBlock('layout', block.getText('layout'))" 
      :variant="setBlock('variant', block.getText('layout'))" 
      :header="block.getText('header')" 
      :text="html(block, 'text')"
      :imageUrl="getLandscapeImageUrl(block)"
      :imageAlt="block.getText('text')"
      :imageTableHeader="block.getText('image-table--header')"
      :imageTableText="html(block, 'image-table--text')"
      :imagesetId="block.data.imageset ? block.data.imageset.value.document.id : null"
      :mobile="mobile" 
      :window="window"></component>
  </section>
</template>

<script>
import Config from 'src/config'
import CoverPhoto from 'components/Collection__Story__CoverPhoto'
import TextBlock from 'components/Collection__Story__Text'
import Spread from 'components/Collection__Story__Spread'
import Diptych from 'components/Collection__Story__Diptych'
import LandscapeImage from 'components/Collection__Story__LandscapeImage'

export default {
  name: 'CollectionStory',
  props: ['window', 'mobile', 'sections'],
  components: {
    CoverPhoto,
    TextBlock,
    Spread,
    Diptych,
    LandscapeImage
  },
  methods: {
    showBlock (block) {
      return block.data['hide-on-mobile'] ? !(this.mobile && block.getBoolean('hide-on-mobile')) : true
    },
    setBlock (key, layout) {
      let block = {
        layout: 'unknown',
        variant: null
      }
      switch (layout) {
        case 'Text':
          block.layout = 'text-block'
          break
        case 'Quote':
          block.layout = 'text-block'
          block.variant = 'quote'
          break
        case 'Spread – Image | Image':
          block.layout = 'spread'
          break
        case 'Spread – Images | Text':
          block.layout = 'spread'
          block.variant = 'topic - reverse'
          break
        case 'Spread – Text | Images':
          block.layout = 'spread'
          block.variant = 'topic'
          break
        case 'Diptych – Black':
          block.layout = 'diptych'
          break
        case 'Diptych – White':
          block.layout = 'diptych'
          block.variant = 'white'
          break
        case 'Landscape Image':
          block.layout = 'landscape-image'
          break
        case 'Bleed Image':
          block.layout = 'cover-photo'
          break
      }
      return block[key]
    },
    html (block, APIid) {
      return block.getStructuredText(APIid) ? block.getStructuredText(APIid).asHtml(Config.prismic) : null
    },
    getLandscapeImageUrl (block) {
      const w = window.innerWidth
      let size = w > 600 ? 'laptop' : 'mobile'
      size = w > 800 ? 'desktop' : size
      size = w > 1024 ? 'main' : size
      const imgObj = block.getImageView('image', size)
      return imgObj ? imgObj.url : null
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.collection-story{ 
  
  // block margins
  .collection-story--block{
    margin-top:$collection-blockMargin-ns;
    // exceptions
    @media (min-width:$bkpt-mobile + 1) {
      @media (max-aspect-ratio:1140/760) {
        // collection topics as spread
        &.collection-topic.collection-spread{
          margin-top:calc(#{$collection-blockMargin-ns} - #{$collection-spreadPad-top} )
        }
        &.collection-topic.collection-spread + .collection-story--block{
          margin-top:calc(#{$collection-spreadRowGutter} - #{$collection-spreadPad-bottom});
        }
      }
      @media (min-aspect-ratio:1140/760){
        &.collection-topic.collection-spread + .collection-story--block{
          margin-top:$collection-spreadRowGutter;
        }
      }
    }
    // mobile
    @include on_mobile () {
      margin-top:$collectionMobile-blockMargin-ns;
    }
  }
  
  // captions
  figcaption{
    margin: $gutter 0 0;
    @include h8('nimbus sans');
  }
}

</style>



// WEBPACK FOOTER //
// Collection__Story.vue?432a6d6f